import React, { useState } from 'react';
import type {
  CalendarComponentEvent,
  CalendarPermissions,
} from '@axiom/validation';

import { CalendarDeleteConfirmationModal } from './CalendarDeleteConfirmationModal';
import { CalendarDeleteModal } from './CalendarDeleteModal';

export type InterviewDeleteModalProps = {
  name?: string;
  permissions: CalendarPermissions;
  onClose: () => void;
  deleteEvent: CalendarComponentEvent;
  onDelete: () => void;
  hideDelete?: boolean;
};

export const CalendarDeleteEventFlow = ({
  name,
  permissions,
  onClose,
  deleteEvent,
  onDelete,
  hideDelete = false,
}: InterviewDeleteModalProps) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  return confirmOpen ? (
    <CalendarDeleteConfirmationModal
      onDelete={onDelete}
      deleteEvent={deleteEvent}
      onClose={onClose}
    />
  ) : (
    <CalendarDeleteModal
      name={name}
      onDelete={onDelete}
      deleteEvent={deleteEvent}
      onClose={onClose}
      permissions={permissions}
      setConfirmOpen={setConfirmOpen}
      hideDelete={hideDelete}
    />
  );
};
